import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { DialogHeaderModule } from 'src/app/angular-core/components/dialog-header/dialog-header.module';
import { LocalizedDateModule } from 'src/app/angular-core/utils/pipes/localized-date/localized-date.pipe.module';
import { MatDialogModule } from '@angular/material/dialog';
import { CookieConsentDialogComponent } from './cookieconsent-dialog.component';


@NgModule({
  declarations: [CookieConsentDialogComponent],
  imports: [
    CommonModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatDividerModule,
    TranslateModule,
    DialogHeaderModule,  
    LocalizedDateModule,
  ], 
  exports: [CookieConsentDialogComponent]
})
export class CookieConsentModule { }